define('vspot-angular/services/org-volunteer-service',['angular'], function (ng) {
    'use strict';

    return ['resources.OrgVolunteer', function (OrgVolunteer) {

        return {
            /*
             * Get a list of all the volunteers for an activity.
             *
             * @param activityId - ID of the activity for which to fetch assignments.
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            query: function(activityId) {
                return OrgVolunteer.query({
                    selected_activity:  activityId
                });
            },

            /**
             * Get a single volunteer.
             * @param id - ID of the volunteer to select.
             * @param activityId - ID of the activity for which to fetch assignments.
             *
             * @returns...?
             */
            get: function (id, activityId) {
                return OrgVolunteer.get({ id: id, selected_activity:  activityId});
            },

            save: function(postData) {
                if( postData && postData.activity_id && !postData.selected_activity ) {
                    // Extend the data with the selected_activity
                     ng.extend( postData, {selected_activity: postData.activity_id});
                }
                return OrgVolunteer.save( postData );
            },

            saveOrCreate: function(postData) {
                if( postData && postData.activity_id && !postData.selected_activity ) {
                    // Extend the data with the selected_activity
                     ng.extend( postData, {selected_activity: postData.activity_id});
                }
                return OrgVolunteer.saveOrCreate( postData );
            },

            update: function (postData) {
                if( postData && postData.activity_id && !postData.selected_activity ) {
                    // Extend the data with the selected_activity
                     ng.extend( postData, {selected_activity: postData.activity_id});
                }
                return OrgVolunteer.update( postData );
            },
            
            delete: function(id, activityId) {
                return OrgVolunteer.delete({
                    id: id,
                    selected_activity:  activityId
                });
            }
        };
    }];
});

